module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_x_black-9fa425567fa9d4063234eb443d12ce35.svg";